import $ from 'jquery';

$(document).ready(function () {

	$(document).on('click', '#coupon-trigger', (e) => {
		e.preventDefault();
		$('.order-coupon-field').toggleClass('open');
	});

	$(document).on('click', '.ajax-add-to-cart', function(e) {
		
		e.preventDefault()

		let button = $(this)

		let quantity = button.data('quantity');

		if(!quantity) {
			button.data('quantity', 1)
		} else {
			quantity = quantity + 1
			button.data('quantity', quantity)
		}

		if( button.hasClass('additional-sale') || button.hasClass('ajax-add-to-cart') ) {
			button.attr('disabled', true)
		}

		triggerAddToCart(button)

	})

	$(document).on('click', '.ajax-add-to-cart-double', function(e) {
		
		e.preventDefault()

		const button = $(this)

		button.attr('disabled', true)
		
		const data = {
			action : 'add_to_cart_ajax_double',
			products : $(this).data('products'),
			quantity : $(this).data('quantity'),
			url: window.location.href
		}

		$.ajax({
			url: ajaxurl,
			type: 'post',
			data: data,
			error: function (response) {
				console.log(response)
			},
			success: function (response) {

				if(response && response.fragments) {

					if(response.fragments && response.fragments['#checkout-mobile']) {
						$('#checkout-mobile').replaceWith(response.fragments['#checkout-mobile'])
					}

					if(response.fragments && response.fragments['#checkout']) {

						if($(window).width() > 700) {
							$('.header-wrapper').removeClass('animate')
						}
						
						$('#checkout').replaceWith(response.fragments['#checkout'])
					}
					
				} 

			},
			complete: function() {
				button.attr('disabled', false)
			}
		});


	})

    const triggerAddToCart = debounce( button => {

		const product = Number(button.data('product'));
		const variation = Number(button.data('variation'));
		const quantity = button.data('quantity');

		const data = {
			action : 'add_to_cart_ajax',
			product_id : product,
			quantity : quantity,
			variation_id : variation,
		};

		$.ajax({
			url: ajaxurl,
			type: 'post',
			data: data,
			error: function (response) {
				console.log(response)
			},
			success: function (response) {

				if( button.hasClass('additional-sale') || button.hasClass('ajax-add-to-cart') ) {
					button.attr('disabled', false)
				}

				button.removeData('quantity');

				if(response && response.fragments) {

					if(! ( button.hasClass('alt-add-to-cart') || button.hasClass('additional-sale') ) ) {

						const productsInCart = JSON.parse(response.fragments.productsInCart);
	
						if(Object.keys(productsInCart).length > 0) {
	
							if(button.find('.count').length) {
								button.find('.count').text(productsInCart[product])
							}
							else {
								button.prepend('<span class="count">' + productsInCart[product] + '</span>')
							}
						}

					}

					if(response.fragments && response.fragments['#checkout-mobile']) {
						$('#checkout-mobile').replaceWith(response.fragments['#checkout-mobile'])
					}

					if(response.fragments && response.fragments['#checkout']) {

						if($(window).width() > 700) {
							$('.header-wrapper').removeClass('animate')
						}
						
						$('#checkout').replaceWith(response.fragments['#checkout'])
					}

					if( $('body').hasClass('checkout') ) {

						if( button.hasClass('additional-sale') ) {
							jQuery( 'body' ).trigger( 'update_checkout' );
						}

					}

					if(! button.hasClass('additional-sale') && response.fragments && response.fragments['#prompt_on_discovery_pack']) {
						$('body > .wrapper').prepend(response.fragments['#prompt_on_discovery_pack']);
						$(document).find('#prompt-discovery-pack').show()
					}
					
				} 
			},
		});

    }, 300)

	function debounce(callback, delay = 1000) {

        let timeout;

        return (...args) => {

            clearTimeout(timeout)
    
            timeout = setTimeout(() => {
                callback(...args)
            }, delay)
        }
    }

	$(document).on('click', '#apply-coupon', (e) => {
		e.preventDefault();
		let coupon = $('#coupon-code').val();

		$.ajax({
			url: ajaxurl,
			type: 'post',
			data: {
				action: 'add_coupon_woocommerce_checkout',
				coupon: coupon,
			},
			error: function (response) {
				console.log(response);
			},
			success: function (response) {
				
				jQuery( 'body' ).trigger( 'update_checkout' );
				
				if($('.order-coupon-field').hasClass('open')) {
					$('.order-coupon-field').removeClass('open');
				} else {
					$('.order-coupon-field').addClass('open');
				}
			},
		});
	});

	$(document).on('focus', '#coupon-code', function(e) {
		let codeField = $(this);

		$(document).on('keypress', function(e) {
			if(e.which == 13) {
				e.preventDefault()
				$( "#apply-coupon" ).click();
				codeField.val('')
			}
		})
	});

	jQuery( document.body ).on( 'update_checkout', function(){
		$('body').addClass('coupon-trigger')
	});

	jQuery( 'form.checkout' ).on( 'checkout_place_order', function() {
		$('body').removeClass('coupon-trigger')
	});

	$(document).on('click', '#checkout-sign-in', function (e) {
		e.preventDefault();
		$('.woocommerce-form-login').toggle();
	});

	if (!$('body').hasClass('happyears-site-14')) {
		$('.woocommerce .woocommerce-checkout #shipping_method li').each(
			function () {
				if (
					$(this)
						.find('label')
						.text()
						.toLowerCase()
						.includes('fedex') ||
					$(this)
						.find('label')
						.text()
						.toLowerCase()
						.includes('expedited') ||
					$(this)
						.find('label')
						.text()
						.toLowerCase()
						.includes('express') ||
					$(this)
						.find('label')
						.text()
						.toLowerCase()
						.includes('tracking')
				) {
					let input = $(this).find('input');

					if (input.attr('checked') === 'checked') {
						$('#billing_phone_field').css('display', 'block');
					}
				}
			},
		);

		$(document).on(
			'change',
			'input[name="shipping_method[0]"]',
			function (e) {
				if (
					$(this)
						.siblings('label')
						.text()
						.toLowerCase()
						.includes('fedex') ||
					$(this)
						.siblings('label')
						.text()
						.toLowerCase()
						.includes('express') ||
					$(this)
						.siblings('label')
						.text()
						.toLowerCase()
						.includes('expedited') ||
					$(this)
						.siblings('label')
						.text()
						.toLowerCase()
						.includes('tracking')
				) {
					$('#billing_phone_field').css('display', 'block');
				} else {
					$('#billing_phone_field').css('display', 'none');
				}
			},
		);
	}

	$(document).on('change', 'input[name="payment_method"]', function (e) {
		if (
			$(this).val() === 'wc_checkout_com_apple_pay' ||
			$(this).val() === 'paypal_express'
		) {
			$('#place_order').hide();
		} else {
			$('#place_order').show();
		}

		$('.checkout-wrapper #billing_phone_field').hide();
	});

	if (
		$('input[name="payment_method"]:checked').val() ===
			'wc_checkout_com_apple_pay' ||
		$('input[name="payment_method"]:checked').val() === 'paypal_express'
	) {
		$('#place_order').hide();
	}

	jQuery('form.variations_form').on('found_variation', function(event, variation) {
		updateVariationOutput(variation)
	});


	function customSelectDisplay(button) {

		const list = $('.custom-select')

		const scrollTop = $(window).scrollTop();
      
		const headerHeight = $('.header-wrapper').outerHeight()

		const buttonOffset = button.offset()

		const buttonPositionTop = buttonOffset.top - scrollTop
		
		if( ( buttonPositionTop - headerHeight ) >= list.outerHeight() ) {
			list.toggleClass('reversed')
		} else {
			list.removeClass('reversed')
		}
		
		list.toggleClass('open')
	}

	$('.custom-select-trigger').on('click', function(e) {
		e.preventDefault()
		$(this).toggleClass('open')
		customSelectDisplay($(this))
	})

	// if( $('body').hasClass('variable-product') ) {

	// 	$(window).on('scroll', function() {
	// 		if( $('.custom-select-trigger').hasClass('open') ) {
	// 			customSelectDisplay($('.custom-select-trigger'))
	// 		}
	// 	})

	// }

	$('.custom-select li').on('click', function(e) {
		
		const variations = jQuery('form.variations_form').data('product_variations');

		const variation = variations.find(prod => prod.variation_id === $(e.target).data('variation'))

		let attr = null
		
		if( variation.attributes ) {
			
			const key = Object.keys(variation.attributes)[0]

			attr = variation.attributes[key]

			$('.variations select').val(attr).trigger('change')
		}

		$('.custom-select li').each(function(index, el) {
			$(el).removeAttr('selected')
			$(e.target).attr('selected', 'selected');
		})

		$('.custom-select').removeClass('open')

		$('.custom-select').removeClass('reversed')

		$('.custom-select-trigger').toggleClass('open')

		$('.custom-select-trigger span').text($(e.target).text())

		$('.ajax-add-to-cart').val($(e.target).data('variation'))

		$('.ajax-add-to-cart').attr('data-variation', $(e.target).data('variation'))

		$('.ajax-add-to-cart').find('div:last-child').replaceWith(`<div>${variation.price_html}</div>`)

		updateVariationOutput(variation)

		
	})

	function updateVariationOutput(variation) {

		$('.new .gallery-wrapper').slick('slickUnfilter');

		if( variation === null ) return
	
		const variationId = variation.variation_id.toString()

		$('.title-price .price').replaceWith(variation.price_html)
	
		$(document).find('.gallery-wrapper .wrapper-gallery-image')
			
		.each(function(index, element) {
	
			const dataVariationId = $(element).data('variation')

			$(element).removeClass('hide')
	
			if( dataVariationId != variationId ) {
				$(element).addClass('hide')
			}
	
		})

		$('.custom-select li').each(function(index, el) {
			$(el).removeAttr('selected')
		})

		const selected = $('.custom-select li[data-variation="'+ variation.variation_id +'"')

		if( selected.length ) {
			selected.attr('selected', 'selected');
			$('.custom-select-trigger span').html(selected.html())
		}

		$(document).trigger('refresh_slider_images');
	
	}

	// Run on page load
	toggleMexicoField();

	jQuery( 'body' ).on('change', 'select[name=billing_country]', function(){
		toggleMexicoField()
	});


	jQuery( 'body' ).on('update_checkout', function() {
		shipping_height()
	})

	if( $('body').hasClass('woocommerce-checkout') ) {

		shipping_height()

		$(document).on('change', 'input[name="shipping_method[0]"]', function (e) {
			shipping_height()
		});

	}


});


function shipping_height(){

	const currentChecked = $(document).find('input[name="shipping_method[0]"]:checked')

	const labelText = currentChecked.siblings('label').text().toLowerCase()

	let hasKeyWord = false

	for( const index in settings.key_words_phone ) {
		
		const word = settings.key_words_phone[index]

		if(labelText.includes(word)) {
			hasKeyWord = true
		}

	}

	if( hasKeyWord ) {
		$(document).find('form.woocommerce-checkout').addClass('flexible')
	} else {
		$(document).find('form.woocommerce-checkout').removeClass('flexible')
	}

}


function toggleMexicoField() {
		
	var country = $('#billing_country').val();

	if (country === 'MX') {
		$('#tax_id_field').show();
		$('#tax_id_field').prop('required', true);
	} else {
		$('#tax_id_field').hide();
		$('#tax_id_field').prop('required', false);
	}
}






// jQuery(function($) {
//     $('form.variations_form').on('found_variation', function(event, variation) {
//         console.log("Variation found:", variation); // Test if this logs correctly in the console
//         // Your additional code here
//     });
// });







